class AppError extends Error {
  constructor(err) {
    super(err.response?.data?.message || err.message);


    if (!err.response) {
      this.network = true;
      this.statusCode = 503;
      this.message = "please check your internet connection or try again later";
      this.status = "error";
      this.unexpected = true;
      return;
    }

    const status = err.response.status;
    const isClientErr = status >= 400 && status < 500;

    if (isClientErr) {
      this.statusCode = status;
      this.status = "fail";
      this.message = err.response.data?.message || "an unknown client error occurred";
    } else {
      this.statusCode = 500;
      this.status = "error";
      this.message = "an unexpected error occurred";
      this.unexpected = true;
    }
  }
}

export default AppError;
